module.exports = __webpack_public_path__ + "static/a2-3543604df7aed9943100d73c41e00163.png";